import { render } from "./LongTextType.vue?vue&type=template&id=1f16a894"
import script from "./LongTextType.vue?vue&type=script&lang=js"
export * from "./LongTextType.vue?vue&type=script&lang=js"

import exportComponent from "/home/tadam/www/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__